import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProLogoImgDirective } from './pro-logo-img.directive';

@NgModule({
    imports: [CommonModule],
    declarations: [ProLogoImgDirective],
    exports: [ProLogoImgDirective],
})
export class ProLogoImgModule {}
